/**
 * About page
 *
 * Copyright (c) 2020 Coursera
 * Author: Kelvin Nguyen
 */
import React from 'react'
import Layout from 'components/Layout'
import { graphql, useStaticQuery } from 'gatsby'

const AboutPage = (props) => {
  const data = useStaticQuery(graphql`
    query {
      contentfulPage(slug: { eq: "about" } siteId: {eq: "About"}) {
        ...PageFragment
      }
    }
  `)

  const aboutPage = data?.contentfulPage || {}

  return (
    <Layout {...props} {...aboutPage} />
  )
}

export default AboutPage
